import http from '@/fetch/http'
import * as types  from '@/vuex/types'
import Vue from 'vue'
const state = {
  totalPaperTopic: {}
}
const actions = {
  setTotalPaperTopic({commit}, totalPaperTopic){
    commit('SET_TOTAL_PAPER_TOPIC', totalPaperTopic);
  }
}

const getters = {}

const mutations = {
  ['SET_TOTAL_PAPER_TOPIC'](state, totalPaperTopic) {
    if(totalPaperTopic == 1){
      state.totalPaperTopic.length = 0;
    }else{
      Vue.set(state, 'totalPaperTopic', totalPaperTopic);
    }
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/createpapermodal.js